import React from 'react';

const Error500PageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/500',
			exact: true,
			component: React.lazy(() => import('./Error500Page'))
		}
	]
};

export default Error500PageConfig;
